module.exports = __webpack_public_path__ + "img/indicator1.6648a551.png";